import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { OnDestroyObservable } from '@entscheidungsnavi/tools';
import { Observable } from 'rxjs';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { matchOtherValidator } from '..';
import { PasswordStrengthComponent } from '../../password-strength/password-strength.component';

/*
  adds password and passwordRepeat to parent form group
  See registrieren.component for Usage Example
**/
@Component({
  selector: 'dt-password-form',
  templateUrl: 'password-form.component.html',
  styleUrls: ['password-form.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatIconButton, MatSuffix, MatIcon, MatError, PasswordStrengthComponent],
})
export class PasswordFormComponent implements OnInit {
  @OnDestroyObservable()
  private onDestroy$: Observable<void>;

  @Input()
  passwordChange = false;
  @Input()
  newPassword = false;

  hidePassword = true;
  passwordValid = false;

  form: FormGroup;

  constructor(public controlContainer: ControlContainer) {}

  ngOnInit() {
    this.form = this.controlContainer.control as FormGroup;

    if (this.passwordChange) {
      this.form.addControl('oldPassword', new UntypedFormControl('', [Validators.required]));
    }
    this.form.addControl('password', new UntypedFormControl('', [Validators.required, Validators.minLength(8)]));
    this.form.addControl(
      'passwordRepeat',
      new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(8),
        matchOtherValidator(this.form.controls.password as UntypedFormControl, this.onDestroy$),
      ]),
    );
  }
}
